// ─── SEED DATA ────────────────────────────────────────────────────────────────
// Static fixtures that populate the in-memory mock DB on start-up.
// Edit freely to add or modify test scenarios.

export const SEED_COMPANIES = [
  {
    id: 1,
    name: 'JIMM Demo S.A.',
    address_line_1: 'Calle Gran Vía 45',
    address_line_2: 'Planta 3',
    city: 'Madrid',
    country: 'España',
    first_contact_person_name: 'María García',
    first_contact_person_email: 'maria.garcia@jimm-demo.com',
    first_contact_person_phone: '+34 600 111 222',
    emergency_contact_person_name: 'Pedro Sánchez',
    emergency_contact_person_email: 'emergencias@jimm-demo.com',
    hasLogo: false,
    logo: null,
  },
  {
    id: 2,
    name: 'Constructora Norte S.L.',
    address_line_1: 'Av. de la Constitución 8',
    address_line_2: '',
    city: 'Bilbao',
    country: 'España',
    first_contact_person_name: 'Luis Fernández',
    first_contact_person_email: 'luis@constructoranorte.com',
    first_contact_person_phone: '+34 600 333 444',
    emergency_contact_person_name: 'Ana Rodríguez',
    emergency_contact_person_email: 'emergency@constructoranorte.com',
    hasLogo: false,
    logo: null,
  },
];

export const SEED_USERS = [
  {
    id: 1,
    confirmed: true,
    first_name: 'Super',
    last_name: 'Admin',
    email: 'superadmin@jimm.com',
    password_hash: '',
    role_id: 1,
    company_id: 1,
    notification_emails: [],
    notification_user_ids: [],
    undetached_alert_minutes: 10,
  },
  {
    id: 2,
    confirmed: true,
    first_name: 'María',
    last_name: 'García',
    email: 'admin@jimm-demo.com',
    password_hash: '',
    role_id: 2,
    company_id: 1,
    notification_emails: ['notif-ext@gmail.com'],
    notification_user_ids: [3],
    undetached_alert_minutes: 5,
  },
  {
    id: 3,
    confirmed: true,
    first_name: 'Carlos',
    last_name: 'López',
    email: 'controlador@jimm-demo.com',
    password_hash: '',
    role_id: 3,
    company_id: 1,
    notification_emails: [],
    notification_user_ids: [],
    undetached_alert_minutes: 3,
  },
  {
    id: 4,
    confirmed: true,
    first_name: 'Elena',
    last_name: 'Torres',
    email: 'elena@jimm-demo.com',
    password_hash: '',
    role_id: 3,
    company_id: 1,
    notification_emails: ['jefe@empresa.com', 'rrhh@empresa.com'],
    notification_user_ids: [2],
    undetached_alert_minutes: 7,
  },
  {
    id: 5,
    confirmed: false,
    first_name: 'Roberto',
    last_name: 'Díaz',
    email: 'roberto@constructoranorte.com',
    password_hash: '',
    role_id: 2,
    company_id: 2,
    notification_emails: [],
    notification_user_ids: [],
    undetached_alert_minutes: 5,
  },
];

export const SEED_WORKERS = [
  { id: 1, first_name: 'Juan',    last_name: 'Martínez',  dni: '12345678A', company_id: 1 },
  { id: 2, first_name: 'Pedro',   last_name: 'Sánchez',   dni: '87654321B', company_id: 1 },
  { id: 3, first_name: 'Ana',     last_name: 'Rodríguez', dni: '11111111C', company_id: 1 },
  { id: 4, first_name: 'Luis',    last_name: 'Fernández', dni: '22222222D', company_id: 1 },
  { id: 5, first_name: 'Elena',   last_name: 'González',  dni: '33333333E', company_id: 1 },
  { id: 6, first_name: 'Marcos',  last_name: 'Vidal',     dni: '44444444F', company_id: 2 },
  { id: 7, first_name: 'Carmen',  last_name: 'Ruiz',      dni: '55555555G', company_id: 2 },
];

export const SEED_ZONES = [
  { id: 1, name: 'Zona Norte',   company_id: 1, country_id: 'ES', description: 'Planta baja – sector norte' },
  { id: 2, name: 'Zona Sur',     company_id: 1, country_id: 'ES', description: 'Primera planta – sector sur' },
  { id: 3, name: 'Almacén A',    company_id: 2, country_id: 'ES', description: 'Nave de almacenaje principal' },
];

export const SEED_PROJECTS = [
  {
    id: 1,
    name: 'Proyecto Alfa',
    start_date: '2024-01-15',
    country: 'España',
    company_id: 1,
    manager_id: 2,
    zone_id: 1,
    zone_name: 'Zona Norte',
    zoneIds: [1],
  },
  {
    id: 2,
    name: 'Proyecto Beta',
    start_date: '2024-03-01',
    country: 'España',
    company_id: 1,
    manager_id: 2,
    zone_id: 2,
    zone_name: 'Zona Sur',
    zoneIds: [2],
  },
  {
    id: 3,
    name: 'Obra Central',
    start_date: '2024-06-10',
    country: 'España',
    company_id: 2,
    manager_id: 5,
    zone_id: 3,
    zone_name: 'Almacén A',
    zoneIds: [3],
  },
];

export const SEED_DEVICES = [
  {
    id: 1,
    serial_number: 'JIM-001',
    assigned: true,
    registered: true,
    company_id: 1,
    project_id: 1,
    project_name: 'Proyecto Alfa',
    zone_id: 1,
    zone_name: 'Zona Norte',
    user_id: 1,
    user_name: 'Juan Martínez',
    current_device_state: 'active',
    current_firmware_name: 'v2.3.1',
  },
  {
    id: 2,
    serial_number: 'JIM-002',
    assigned: true,
    registered: true,
    company_id: 1,
    project_id: 1,
    project_name: 'Proyecto Alfa',
    zone_id: 1,
    zone_name: 'Zona Norte',
    user_id: 2,
    user_name: 'Pedro Fernandez',
    current_device_state: 'preactive',
    current_firmware_name: 'v2.3.1',
  },
  {
    id: 3,
    serial_number: 'JIM-003',
    assigned: false,
    registered: true,
    company_id: 1,
    project_id: null,
    project_name: null,
    zone_id: null,
    zone_name: null,
    user_id: null,
    user_name: null,
    current_device_state: 'inactive',
    current_firmware_name: 'v2.2.0',
  },
  {
    id: 4,
    serial_number: 'JIM-004',
    assigned: true,
    registered: true,
    company_id: 2,
    project_id: 3,
    project_name: 'Obra Central',
    zone_id: 3,
    zone_name: 'Almacén A',
    user_id: 5,
    user_name: 'Roberto Díaz',
    current_device_state: 'active',
    current_firmware_name: 'v2.3.1',
  },
];

export const SEED_ALARM_CONFIGS = [
  {
    alarm_type: 1,
    retention_time: 5,
    timetable: '1111100',   // Mon–Fri
    start_time: 8,
    finish_time: 18,
    start_time2: 0,
    finish_time2: 0,
    parent_type: 'C',
    parent_id: 1,
  },
  {
    alarm_type: 1,
    retention_time: 2,
    timetable: '1111111',   // all week
    start_time: 7,
    finish_time: 20,
    start_time2: 0,
    finish_time2: 0,
    parent_type: 'W',
    parent_id: 1,
  },
  {
    alarm_type: 1,
    retention_time: 5,
    timetable: '1111100',
    start_time: 8,
    finish_time: 17,
    start_time2: 0,
    finish_time2: 0,
    parent_type: 'C',
    parent_id: 2,
  },
];

export const SEED_CONFIGURATIONS = [
  {
    device_id: 1,
    company_id: 1,
    serial_number: 'JIM-001',
    desired_active_sampling_time: 30,
    desired_preactive_sampling_time: 60,
    desired_active_sending_time: 300,
    desired_preactive_sending_time: 600,
    desired_state: 'active',
    update_name: null,
  },
  {
    device_id: 2,
    company_id: 1,
    serial_number: 'JIM-002',
    desired_active_sampling_time: 30,
    desired_preactive_sampling_time: 60,
    desired_active_sending_time: 300,
    desired_preactive_sending_time: 600,
    desired_state: 'preactive',
    update_name: null,
  },
];

// Credentials accepted in mock login (any password works for any of these emails)
export const SEED_CREDENTIALS = [
  { email: 'superadmin@jimm.com',         userId: 1, roleId: 1, companyId: 1 },
  { email: 'admin@jimm-demo.com',         userId: 2, roleId: 2, companyId: 1 },
  { email: 'controlador@jimm-demo.com',   userId: 3, roleId: 3, companyId: 1 },
  { email: 'elena@jimm-demo.com',         userId: 4, roleId: 3, companyId: 1 },
  { email: 'roberto@constructoranorte.com', userId: 5, roleId: 2, companyId: 2 },
];
